<div class="fdk-dialog-actions">
  <ng-content></ng-content>
</div>
